import { Table } from '@campx-org/shared'
import { Cached } from '@mui/icons-material'
import { Box, Stack, styled, Typography } from '@mui/material'
import { QuestionPaperPanelProps } from './EvaluatorEditor'
import {
  RefreshButton,
  StyledFooterContainer,
  StyledMarksContainer,
} from './Styles'

const scrollbar = {
  '&::-webkit-scrollbar': {
    width: '1em',
    height: '0.5em',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
    borderRadius: '3px',

    '&:hover': {
      background: 'rgba(0, 0, 0, 0.2)',
    },
  },
}

export const StyledActionsContainer = styled(Box)(({ theme }) => ({
  padding: '5px 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `3px solid ${theme.palette.secondary.light}`,
  height: '60px',
}))

export const StyledQuestionsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  '& .table': {
    padding: '5px',
    paddingBottom: '20px',
    overflowY: 'auto',
    height: 'calc(100vh - 64px - 70px - 40px)',
    boxShadow: '0px -10px 20px rgba(0, 0, 0, 0.1) inset',
    ...scrollbar,
  },
  '& .footer': {
    height: '60px',
    color: 'white',
    padding: '10px 20px',
    backgroundColor: '#121212',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))

function QuestionsPanel({
  questionPaperProps,
}: {
  questionPaperProps: QuestionPaperPanelProps
}) {
  const { questionsPanelActions, handleRefresh, columns, records, evaluators } =
    questionPaperProps

  return (
    <>
      <StyledQuestionsContainer>
        <StyledActionsContainer>{questionsPanelActions}</StyledActionsContainer>

        <Box className="table">
          <Table columns={columns} dataSource={records} key={'id'} dense />
        </Box>

        <Box>
          <StyledFooterContainer>
            <Typography
              variant="h5"
              sx={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}
            >
              Total Awarded Marks :
            </Typography>

            <Stack direction={'row'} gap={1}>
              {evaluators.map((evaluator, index) => (
                <StyledMarksContainer key={index}>
                  <Typography>{evaluator.obtainedMarks} </Typography>
                  <Typography>{` / ${evaluator.totalMarks}`}</Typography>
                </StyledMarksContainer>
              ))}
              <RefreshButton onClick={handleRefresh}>
                <Cached />
              </RefreshButton>
            </Stack>
          </StyledFooterContainer>
        </Box>
      </StyledQuestionsContainer>
    </>
  )
}

export default QuestionsPanel
